import { render, staticRenderFns } from "./PageNotFoundView.vue?vue&type=template&id=18bf5369&scoped=true&"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js&"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js&"
import style0 from "./PageNotFoundView.vue?vue&type=style&index=0&id=18bf5369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf5369",
  null
  
)

export default component.exports